import { Box, Flex, Image, Text } from '@chakra-ui/react';

type TicketsBoxProps = {
  data: {
    image: string;
    destinationName: string;
  };
};

const TicketsBox = ({ data }: TicketsBoxProps) => {
  return (
    <Box width={400} height={260} position='relative'>
        <Image borderRadius='25px' src={data.image} />
        <Flex alignItems='center' position='absolute' bottom='40px' left='15px'>
        <Text color='white' fontSize='4xl' fontWeight={700}>
            {data.destinationName}
        </Text>
        </Flex>
    </Box>
  );
};

export { TicketsBox };
